import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function ShortTestimonials() {
  const testimonials = [{
    quote: 'Tengo todo planificado hasta diciembre. Mis domingos volvieron a ser míos.',
    author: 'M.L., Córdoba'
  }, {
    quote: 'Ya viene todo secuenciado. No tengo que pensar el orden, solo imprimir y aplicar.',
    author: 'V.R., Rosario'
  }, {
    quote: 'Las rúbricas y fichas son un lujo. Hago los informes en la mitad de tiempo.',
    author: 'S.G., CABA'
  }];
  return <section className="w-full bg-transparent py-10" data-id="element-148" data-mp="3i1kf61pfbjlw">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-149" data-mp="3vtqmqzeigi9q">
        <div className="text-center mb-6" data-id="element-150" data-mp="3rt6lbjmwmshs">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C084FC] font-semibold mb-1" data-id="element-151" data-mp="3ruhqnnw008b0">
            Lo que dicen nuestras profesionales
          </p>
          <h2 className="text-xl md:text-3xl font-bold text-white font-['Open_Sans',_sans-serif]" data-id="element-152" data-mp="4oiclb6tpjyb">
            Testimonios <span className="text-[#9333EA]" data-id="element-153" data-mp="2tw4ldnyj00q4">reales</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-154" data-mp="2yuo65l1dv6gw">
          {testimonials.map((t, index) => <div key={index} className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-5 hover:border-[#C084FC]/30 transition-all duration-200 flex flex-col" data-id="element-155" data-mp="33t9bfyvhsgc7" data-mpi={index}>
              <QuoteIcon className="w-5 h-5 text-[#C084FC]/60 mb-3" data-id="element-156" data-mp="3cuz2v4pdjf9z" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-157" data-mp="3csmjcn3ywwut">
                "{t.quote}"
              </p>
              <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#2A2A2A]" data-id="element-158" data-mp="3mjqokv3ud3cg">
                <span className="text-[11px] font-semibold text-white" data-id="element-159" data-mp="3rjv5gm8nw037">
                  {t.author}
                </span>
                <div className="flex gap-0.5 text-yellow-400" data-id="element-160" data-mp="3vm01tsqhvatj">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="w-3 h-3 fill-current" data-id="element-161" data-mp="20hiofcf5fil4" data-mpi={i} />)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}